import { useQuery } from "@apollo/client";
import { GET_USER_DETAILS } from "../../apis/dashboard-apis/dashboardDetailApi";

// These companies only get the modules below, and only admins can use the
// app: no dashboard, employee view or auditor view. Compared case-insensitively
// against customer_company_name.
const RESTRICTED_COMPANY_NAMES = ["bidgely"];

export const RESTRICTED_HOME_ROUTE = "/infrastructure";

// Same shape as the admin entry of the customer's sidebar permissions
export const RESTRICTED_SIDEBAR_SECTIONS = {
  Security: { order: 1, permissionsData: ["Infrastructure", "Code Security"] },
  "Set up": {
    order: 2,
    permissionsData: ["Integrations", "Company Settings"],
  },
};

// /checks/:checkType is the check detail page opened from Infrastructure and
// Code Security. /code-security and /company-profile are legacy redirects.
const RESTRICTED_ALLOWED_PATHS = [
  "/infrastructure",
  "/admin/code-security",
  "/code-security",
  "/checks",
  "/integrations",
  "/company-settings",
  "/company-profile",
];

export const isPathAllowedForRestrictedAccess = (pathname) =>
  RESTRICTED_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

export const useRestrictedModuleAccess = () => {
  const { data } = useQuery(GET_USER_DETAILS);
  const companyName = data?.getAccountDetails?.userCompanyDetails
    ?.customer_company_name?.trim()
    .toLowerCase();

  if (!companyName) return false;
  return RESTRICTED_COMPANY_NAMES.some(
    (name) => name.trim().toLowerCase() === companyName
  );
};
